import React from 'react';
import { components } from 'react-select';
import { ChevronDown } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';

export default (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <ChevronDown color={CFM_STONE} />
        </components.DropdownIndicator>
    );
